module.exports = __webpack_public_path__ + "static/media/34-web-or-mls-DSC06817.2bb72032.jpg";